import React from 'react';

function IconLightTheme() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      fill="none"
      viewBox="0 0 21 21"
    >
      <path
        fillRule="evenodd"
        d="M10.5 5.75a4.75 4.75 0 100 9.5 4.75 4.75 0 000-9.5zM4.25 10.5a6.25 6.25 0 1112.5 0 6.25 6.25 0 01-12.5 0zM10.5.25a.75.75 0 01.75.75v.078a.75.75 0 01-1.5 0V1a.75.75 0 01.75-.75zM3.184 3.184a.75.75 0 011.06 0l.124.123a.75.75 0 11-1.06 1.061l-.124-.123a.75.75 0 010-1.061zm14.632 0a.75.75 0 010 1.06l-.123.124a.75.75 0 01-1.061-1.06l.123-.124a.75.75 0 011.061 0zM.25 10.5A.75.75 0 011 9.75h.078a.75.75 0 010 1.5H1a.75.75 0 01-.75-.75zm18.922 0a.75.75 0 01.75-.75H20a.75.75 0 010 1.5h-.078a.75.75 0 01-.75-.75zm-2.54 6.132a.75.75 0 011.06 0l.124.123a.75.75 0 01-1.06 1.061l-.124-.123a.75.75 0 010-1.06zm-12.264 0a.75.75 0 010 1.06l-.123.124a.75.75 0 01-1.061-1.06l.123-.124a.75.75 0 011.06 0zm6.132 2.54a.75.75 0 01.75.75V20a.75.75 0 01-1.5 0v-.078a.75.75 0 01.75-.75z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default IconLightTheme;
